import React from 'react';

/** Shown when list prices are USD and Stripe Adaptive Pricing converts at checkout. */
export function AdaptivePricingNote({ className = '' }: { className?: string }) {
  return (
    <p
      className={`text-sm text-gray-600 dark:text-gray-400 ${className}`.trim()}
      data-testid="adaptive-pricing-note"
    >
      Prices shown in USD. At checkout, Stripe automatically converts to your local currency and
      calculates tax for your location.
    </p>
  );
}
